import { baseHttp } from '../http'
import {
  AccountLoginThirdReq,
  AccountLoginThirdRes,
  AccountRefreshTokenReq,
  AccountRegisterEmailReq,
  AccountLoginEmailReq,
  AccountLoginEmailRes,
  AccountResetPasswordReq,
} from './types/account'

// 第三方登录
export const accountLoginThird = (data: AccountLoginThirdReq) => {
  return baseHttp.post<AccountLoginThirdRes>('/account/login/third', data)
}

// 退出登录
export const accountLogout = (sdk_token: string) => {
  return baseHttp.post<any>('/account/logout', { sdk_token })
}

// 刷新Token
export const accountRefreshToken = (data: AccountRefreshTokenReq) => {
  return baseHttp.post<AccountLoginThirdRes>('/account/refresh_token', data)
}

// 注销账号
export const accountRevoke = (sdk_token: string) => {
  return baseHttp.post<any>('/account/revoke', { sdk_token })
}

// 邮箱注册
export const accountRegisterEmail = (data: AccountRegisterEmailReq) => {
  return baseHttp.post<any>('/account/register/email', data)
}

// 邮箱登录
export const accountLoginEmail = (data: AccountLoginEmailReq) => {
  return baseHttp.post<AccountLoginEmailRes>('/account/login/email', data)
}

// 重置密码
export const accountResetPassword = (data: AccountResetPasswordReq) => {
  return baseHttp.post<any>('/account/reset_password', data)
}

// 忘记密码
export const accountForgetPassword = (data: { email: string }) => {
  return baseHttp.post<any>('/account/forget_password', data)
}

// 验证忘记密码链接
export const accountVerifyForgetPasswordLink = (data: { credential: string }) => {
  return baseHttp.post<any>('/account/verify_forget_password_link', data)
}
